import { JSX } from "react";
import { FolderOutlined } from "@ant-design/icons";

import { Container_MST1010_R01 } from "src/containers/mes/MST/MST1010_R01/Container_MST1010_R01";
import { Container_MST1011_R01 } from "src/containers/mes/MST/MST1011_R01/Container_MST1011_R01";
import { Container_MST1110_R01 } from "src/containers/mes/MST/MST1110_R01/Container_MST1110_R01";
import { Container_MST1020_R01 } from "src/containers/mes/MST/MST1020_R01/Container_MST1020_R01";
import { Container_MST1030_R01 } from "src/containers/mes/MST/MST1030_R01/Container_MST1030_R01";
import { Container_MST1060_R10 } from "src/containers/mes/MST/MST1060_R10/Container_MST1060_R10";
import { Container_MST2010_R01 } from "src/containers/mes/MST/MST2010_R01/Container_MST2010_R01";
import { Container_MST2020_R01 } from "src/containers/mes/MST/MST2020_R01/Container_MST2020_R01";
import { Container_MST3010_R01 } from "src/containers/mes/MST/MST3010_R01/Container_MST3010_R01";
import { Container_MST3020_R01 } from "src/containers/mes/MST/MST3020_R01/Container_MST3020_R01";
import { Container_MST3040_R01 } from "src/containers/mes/MST/MST3040_R01/Container_MST3040_R01";
import { Container_MST3050_R01 } from "src/containers/mes/MST/MST3050_R01/Container_MST3050_R01";
import { Container_MST4010_R01 } from "src/containers/mes/MST/MST4010_R01/Container_MST4010_R01";
import { Container_MST4030_R01 } from "src/containers/mes/MST/MST4030_R01/Container_MST4030_R01";
import { Container_MST4040_R01 } from "src/containers/mes/MST/MST4040_R01/Container_MST4040_R01";
import { Container_MST4050_R01 } from "src/containers/mes/MST/MST4050_R01/Container_MST4050_R01";
import { Container_MST4060_R01 } from "src/containers/mes/MST/MST4060_R01/Container_MST4060_R01";
import { Container_MST7020_R01 } from "src/containers/mes/MST/MST7020_R01/Container_MST7020_R01";

import { Container_PRD1010_R01 } from "src/containers/mes/PRD/PRD1010_R01/Container_PRD1010_R01";
import { Container_PRD1020_R01 } from "src/containers/mes/PRD/PRD1020_R01/Container_PRD1020_R01";
import { Container_PRD2010_R01 } from "src/containers/mes/PRD/PRD2010_R01/Container_PRD2010_R01";
import { Container_PRD2030_R01 } from "src/containers/mes/PRD/PRD2030_R01/Container_PRD2030_R01";
import { Container_PRD2040_R01 } from "src/containers/mes/PRD/PRD2040_R01/Container_PRD2040_R01";
import { Container_PRD2050_R01 } from "src/containers/mes/PRD/PRD2050_R01/Container_PRD2050_R01";
import { Container_PRD3010_R01 } from "src/containers/mes/PRD/PRD3010_R01/Container_PRD3010_R01";
import { Container_PRD3011_R01 } from "src/containers/mes/PRD/PRD3011_R01/Container_PRD3011_R01";
import { Container_PRD3012_R01 } from "src/containers/mes/PRD/PRD3012_R01/Container_PRD3012_R01";
import { Container_PRD3020_R01 } from "src/containers/mes/PRD/PRD3020_R01/Container_PRD3020_R01";
import { Container_PRD3030_R01 } from "src/containers/mes/PRD/PRD3030_R01/Container_PRD3030_R01";
import { Container_PRD3031_R01 } from "src/containers/mes/PRD/PRD3031_R01/Container_PRD3031_R01";
import { Container_PRD3040_R01 } from "src/containers/mes/PRD/PRD3040_R01/Container_PRD3040_R01";
import { Container_PRD3050_R01 } from "src/containers/mes/PRD/PRD3050_R01/Container_PRD3050_R01";
import { Container_PRD3060_R01 } from "src/containers/mes/PRD/PRD3060_R01/Container_PRD3060_R01";
import { Container_PRD4060_R01 } from "src/containers/mes/PRD/PRD4060_R01/Container_PRD4060_R01";
import { Container_PRD4010_R01 } from "src/containers/mes/PRD/PRD4010_R01/Container_PRD4010_R01";
import { Container_PRD4011_R01 } from "src/containers/mes/PRD/PRD4011_R01/Container_PRD4011_R01";
import { Container_PRD5010_R01 } from "src/containers/mes/PRD/PRD5010_R01/Container_PRD5010_R01";
import { Container_PRD5011_R01 } from "src/containers/mes/PRD/PRD5011_R01/Container_PRD5011_R01";
import { Container_PRD5020_R01 } from "src/containers/mes/PRD/PRD5020_R01/Container_PRD5020_R01";
import { Container_PRD5030_R01 } from "src/containers/mes/PRD/PRD5030_R01/Container_PRD5030_R01";
import { Container_PRD5040_R01} from "src/containers/mes/PRD/PRD5040_R01/Container_PRD5040_R01";
import Container_PRD5050_R01 from "src/containers/mes/PRD/PRD5050_R01/Container_PRD5050_R01";

import { Container_PUR1020_R01 } from "src/containers/mes/PUR/PUR1020_R01/Container_PUR1020_R01";
import { Container_PUR1021_R01 } from "src/containers/mes/PUR/PUR1021_R01/Container_PUR1021_R01";
import { Container_PUR1030_R01 } from "src/containers/mes/PUR/PUR1030_R01/Container_PUR1030_R01";
import { Container_PUR1040_R01 } from "src/containers/mes/PUR/PUR1040_R01/Container_PUR1040_R01";
import { Container_PUR2010_R01 } from "src/containers/mes/PUR/PUR2010_R01/Container_PUR2010_R01";
import { Container_PUR2020_R01 } from "src/containers/mes/PUR/PUR2020_R01/Container_PUR2020_R01";
import { Container_PUR2040_R01 } from "src/containers/mes/PUR/PUR2040_R01/Container_PUR2040_R01";
import { Container_PUR5010_R01 } from "src/containers/mes/PUR/PUR5010_R01/Container_PUR5010_R01";
import { Container_PUR5020_R01 } from "src/containers/mes/PUR/PUR5020_R01/Container_PUR5020_R01";
import { Container_PUR6010_R01 } from "src/containers/mes/PUR/PUR6010_R01/Container_PUR6010_R01";

import { Container_SAL1010_R01 } from "src/containers/mes/SAL/SAL1010_R01/Container_SAL1010_R01";
import { Container_SAL1011_R01 } from "src/containers/mes/SAL/SAL1011_R01/Container_SAL1011_R01";
import { Container_SAL1020_R01 } from "src/containers/mes/SAL/SAL1020_R01/Container_SAL1020_R01";
import { Container_SAL1030_R01 } from "src/containers/mes/SAL/SAL1030_R01/Container_SAL1030_R01";
import { Container_SAL2020_R01 } from "src/containers/mes/SAL/SAL2020_R01/Container_SAL2020_R01";
import { Container_SAL2030_R01 } from "src/containers/mes/SAL/SAL2030_R01/Container_SAL2030_R01";
import { Container_SAL2040_R01 } from "src/containers/mes/SAL/SAL2040_R01/Container_SAL2040_R01";
import { Container_SAL2050_R01 } from "src/containers/mes/SAL/SAL2050_R01/Container_SAL2050_R01";
import Container_SAL2060_R01 from "src/containers/mes/SAL/SAL2060_R01/Container_SAL2060_R01";
import { Container_SAL2070_R01 } from "src/containers/mes/SAL/SAL2070_R01/Container_SAL2070_R01";
import { Container_SAL2080_R01 } from "src/containers/mes/SAL/SAL2080_R01/Container_SAL2080_R01";
import { Container_SAL2090_R01 } from "src/containers/mes/SAL/SAL2090_R01/Container_SAL2090_R01";
import { Container_SAL2110_R01 } from "src/containers/mes/SAL/SAL2110_R01/Container_SAL2110_R01";
import { Container_SAL2100_R01 } from "src/containers/mes/SAL/SAL2100_R01/Container_SAL2100_R01";
import { Container_SAL3010_R01 } from "src/containers/mes/SAL/SAL3010_R01/Container_SAL3010_R01";
import { Container_SAL3050_R01 } from "src/containers/mes/SAL/SAL3050_R01/Container_SAL3050_R01";
import { Container_SAL6010_R01 } from "src/containers/mes/SAL/SAL6010_R01/Container_SAL6010_R01";
import { Container_SAL6020_R01 } from "src/containers/mes/SAL/SAL6020_R01/Container_SAL6020_R01";
import { Container_SAL6030_R01 } from "src/containers/mes/SAL/SAL6030_R01/Container_SAL6030_R01";

import { Container_SYS1010_R01 } from "src/containers/mes/SYS/SYS1010_R01/Container_SYS1010_R01";
import { Container_SYS1020_R01 } from "src/containers/mes/SYS/SYS1020_R01/Container_SYS1020_R01";
import { Container_SYS2010_R01 } from "src/containers/mes/SYS/SYS2010_R01/Container_SYS2010_R01";
import { Container_SYS2020_R01 } from "src/containers/mes/SYS/SYS2020_R01/Container_SYS2020_R01";
import { Container_SYS3010_R01 } from "src/containers/mes/SYS/SYS3010_R01/Container_SYS3010_R01";
import { Container_SYS3020_R01 } from "src/containers/mes/SYS/SYS3020_R01/Container_SYS3020_R01";
import { Container_SYS3050_R01 } from "src/containers/mes/SYS/SYS3050_R01/Container_SYS3050_R01";
import { Container_SYS3060_R01 } from "src/containers/mes/SYS/SYS3060_R01/Container_SYS3060_R01";
import { Container_SYS4010_R01 } from "src/containers/mes/SYS/SYS4010_R01/Container_SYS4010_R01";
import { Container_SYS4030_R01 } from "src/containers/mes/SYS/SYS4030_R01/Container_SYS4030_R01";
import { Container_SYS4090_R01 } from "src/containers/mes/SYS/SYS4090_R01/Container_SYS4090_R01";
import { Container_HRM2130_R01 } from "src/containers/mes/HRM/HRM2130_R01/Container_HRM2130_R01";
import { Container_HRM3130_R01 } from "src/containers/mes/HRM/HRM3130_R01/Container_HRM3130_R01";
import { Container_HRM1060_R01 } from "src/containers/mes/HRM/HRM1060_R01/Container_HRM1060_R01";
import { Container_HRM2040_R01 } from "src/containers/mes/HRM/HRM2040_R01/Container_HRM2040_R01";
import { Container_HRM3110_R01 } from "src/containers/mes/HRM/HRM3110_R01/Container_HRM3110_R01";
import { Container_HRM3050_R01 } from "src/containers/mes/HRM/HRM3050_R01/Container_HRM3050_R01";
import { Container_HRM1040_R01 } from "src/containers/mes/HRM/HRM1040_R01/Container_HRM1040_R01";
import { Container_HRM1030_R01 } from "src/containers/mes/HRM/HRM1030_R01/Container_HRM1030_R01";
import { Container_HRM2120_R01 } from "src/containers/mes/HRM/HRM2120_R01/Container_HRM2120_R01";
import { Container_HRM2010_R01 } from "src/containers/mes/HRM/HRM2010_R01/Container_HRM2010_R01";
import { Container_SYS4100_R01 } from "src/containers/mes/SYS/SYS4100_R01/Container_SYS4100_R01";
import { Container_SYS4110_R01 } from "src/containers/mes/SYS/SYS4110_R01/Container_SYS4110_R01";
import { Container_SYS4120_R01 } from "src/containers/mes/SYS/SYS4120_R01/Container_SYS4120_R01";
import { Container_SYS5010_R01 } from "src/containers/mes/SYS/SYS5010_R01/Container_SYS5010_R01";
import { Container_SYS5020_R01 } from "src/containers/mes/SYS/SYS5020_R01/Container_SYS5020_R01";


import { Container_WMS1020_R01 } from "src/containers/mes/WMS/WMS1020_R01/Container_WMS1020_R01";
import { Container_WMS1021_R01 } from "src/containers/mes/WMS/WMS1021_R01/Container_WMS1021_R01";
import { Container_WMS1022_R01 } from "src/containers/mes/WMS/WMS1022_R01/Container_WMS1022_R01";
import { Container_WMS1030_R01 } from "src/containers/mes/WMS/WMS1030_R01/Container_WMS1030_R01";
import { Container_WMS1031_R01 } from "src/containers/mes/WMS/WMS1031_R01/Container_WMS1031_R01";
import { Container_WMS1060_R01 } from "src/containers/mes/WMS/WMS1060_R01/Container_WMS1060_R01";
import { Container_WMS1100_R01 } from "src/containers/mes/WMS/WMS1100_R01/Container_WMS1100_R01";
import { Container_WMS1101_R01 } from "src/containers/mes/WMS/WMS1101_R01/Container_WMS1101_R01";
import { Container_WMS2010_R01 } from "src/containers/mes/WMS/WMS2010_R01/Container_WMS2010_R01";
import { Container_WMS2011_R01 } from "src/containers/mes/WMS/WMS2011_R01/Container_WMS2011_R01";
import { Container_WMS2020_R01 } from "src/containers/mes/WMS/WMS2020_R01/Container_WMS2020_R01";
import { Container_WMS2021_R01 } from "src/containers/mes/WMS/WMS2021_R01/Container_WMS2021_R01";
import { Container_WMS2040_R01 } from "src/containers/mes/WMS/WMS2040_R01/Container_WMS2040_R01";
import { Container_WMS2060_R01 } from "src/containers/mes/WMS/WMS2060_R01/Container_WMS2060_R01";
import { Container_WMS2061_R01 } from "src/containers/mes/WMS/WMS2061_R01/Container_WMS2061_R01";
// WMS1120_R01은 TQC3020_R01 전환 후 비활성 상태로 파일만 유지한다.
// import { Container_WMS1120_R01 } from "src/containers/mes/WMS/WMS1120_R01/Container_WMS1120_R01";
import { Container_WMS1130_R01 } from "src/containers/mes/WMS/WMS1130_R01/Container_WMS1130_R01";
import { Container_WMS1131_R01 } from "src/containers/mes/WMS/WMS1131_R01/Container_WMS1131_R01";
import { Container_WMS1140_R01 } from "src/containers/mes/WMS/WMS1140_R01/Container_WMS1140_R01";
import { Container_WMS1141_R01 } from "src/containers/mes/WMS/WMS1141_R01/Container_WMS1141_R01";
import { Container_WMS2090_R01 } from "src/containers/mes/WMS/WMS2090_R01/Container_WMS2090_R01";
import { Container_WMS2091_R01 } from "src/containers/mes/WMS/WMS2091_R01/Container_WMS2091_R01";

import { Container_EQM1010_R01 } from "src/containers/mes/EQM/EQM1010_R01/Container_EQM1010_R01";
import { Container_EQM1011_R01 } from "src/containers/mes/EQM/EQM1011_R01/Container_EQM1011_R01";
import { Container_EQM1020_R01 } from "src/containers/mes/EQM/EQM1020_R01/Container_EQM1020_R01";
import { Container_EQM1030_R01 } from "src/containers/mes/EQM/EQM1030_R01/Container_EQM1030_R01";
import { Container_EQM2010_R01 } from "src/containers/mes/EQM/EQM2010_R01/Container_EQM2010_R01";
import { Container_EQM2020_R01 } from "src/containers/mes/EQM/EQM2020_R01/Container_EQM2020_R01";
import { Container_EQM2040_R01 } from "src/containers/mes/EQM/EQM2040_R01/Container_EQM2040_R01";
import { Container_EQM2050_R01 } from "src/containers/mes/EQM/EQM2050_R01/Container_EQM2050_R01";
import { Container_EQM2060_R01 } from "src/containers/mes/EQM/EQM2060_R01/Container_EQM2060_R01";
import { Container_EQM2070_R01 } from "src/containers/mes/EQM/EQM2070_R01/Container_EQM2070_R01";
import { Container_TQC2100_R01 } from "src/containers/mes/TQC/TQC2100_R01/Container_TQC2100_R01";
import { Container_EQM2080_R01 } from "src/containers/mes/EQM/EQM2080_R01/Container_EQM2080_R01";
import { Container_EQM3010_R01 } from "src/containers/mes/EQM/EQM3010_R01/Container_EQM3010_R01";
import { Container_EQM3020_R01 } from "src/containers/mes/EQM/EQM3020_R01/Container_EQM3020_R01";
import { Container_EQM4010_R01 } from "src/containers/mes/EQM/EQM4010_R01/Container_EQM4010_R01";

import { Container_TQC2010_R01 } from "src/containers/mes/TQC/TQC2010_R01/Container_TQC2010_R01";
import { Container_TQC2011_R01 } from "src/containers/mes/TQC/TQC2011_R01/Container_TQC2011_R01";
import { Container_TQC2020_R01 } from "src/containers/mes/TQC/TQC2020_R01/Container_TQC2020_R01";
import { Container_TQC1020_R01 } from "src/containers/mes/TQC/TQC1020_R01/Container_TQC1020_R01";
import { Container_TQC1040_R01 } from "src/containers/mes/TQC/TQC1040_R01/Container_TQC1040_R01";
import { Container_TQC1050_R01 } from "src/containers/mes/TQC/TQC1050_R01/Container_TQC1050_R01";
import { Container_TQC1060_R01 } from "src/containers/mes/TQC/TQC1060_R01/Container_TQC1060_R01";
import { Container_TQC2050_R01 } from "src/containers/mes/TQC/TQC2050_R01/Container_TQC2050_R01";
import { Container_TQC2060_R01 } from "src/containers/mes/TQC/TQC2060_R01/Container_TQC2060_R01";
import { Container_TQC2070_R01 } from "src/containers/mes/TQC/TQC2070_R01/Container_TQC2070_R01";
import { Container_TQC2080_R01 } from "src/containers/mes/TQC/TQC2080_R01/Container_TQC2080_R01";
import { Container_TQC2090_R01 } from "src/containers/mes/TQC/TQC2090_R01/Container_TQC2090_R01";
import { Container_TQC3010_R01 } from "src/containers/mes/TQC/TQC3010_R01/Container_TQC3010_R01";
import { Container_TQC3020_R01 } from "src/containers/mes/TQC/TQC3020_R01/Container_TQC3020_R01";
import { Container_TQC5010_R01 } from "src/containers/mes/TQC/TQC5010_R01/Container_TQC5010_R01";
import { Container_TQC5020_R01 } from "src/containers/mes/TQC/TQC5020_R01/Container_TQC5020_R01";

import { MenuDto } from "src/dtos/menu/menuDto";



export const getMenuComponent = (menuCd: string) => {
    let component = null;

	if      (menuCd === 'MST1010_R01')		{ component = Container_MST1010_R01;   }
	else if (menuCd === 'MST1011_R01')		{ component = Container_MST1011_R01;   }
	else if (menuCd === 'MST1110_R01')		{ component = Container_MST1110_R01;   }
	else if (menuCd === 'MST1020_R01')		{ component = Container_MST1020_R01;   }
	else if (menuCd === 'MST1030_R01')		{ component = Container_MST1030_R01;   }
	else if (menuCd === 'MST1060_R10')		{ component = Container_MST1060_R10;   }
	else if (menuCd === 'MST2010_R01')		{ component = Container_MST2010_R01;   }
	else if (menuCd === 'MST2020_R01')		{ component = Container_MST2020_R01;   }
	else if (menuCd === 'MST3010_R01')		{ component = Container_MST3010_R01;   }
	else if (menuCd === 'MST3020_R01')		{ component = Container_MST3020_R01;   }
	else if (menuCd === 'MST3040_R01')		{ component = Container_MST3040_R01;   }
	else if (menuCd === 'MST3050_R01')		{ component = Container_MST3050_R01;   }
	else if (menuCd === 'MST4010_R01')		{ component = Container_MST4010_R01;   }
	else if (menuCd === 'MST4030_R01')		{ component = Container_MST4030_R01;   }
	else if (menuCd === 'MST4040_R01')		{ component = Container_MST4040_R01;   }
	else if (menuCd === 'MST4050_R01')		{ component = Container_MST4050_R01;   }
	else if (menuCd === 'MST4060_R01')		{ component = Container_MST4060_R01;   }
	else if (menuCd === 'MST7020_R01')		{ component = Container_MST7020_R01;   }

	else if (menuCd === 'PRD1010_R01')		{ component = Container_PRD1010_R01;   }
	else if (menuCd === 'PRD1020_R01')		{ component = Container_PRD1020_R01;   }
	else if (menuCd === 'PRD2010_R01')		{ component = Container_PRD2010_R01;   }
	else if (menuCd === 'PRD2030_R01')		{ component = Container_PRD2030_R01;   }
	else if (menuCd === 'PRD2040_R01')		{ component = Container_PRD2040_R01;   }
	else if (menuCd === 'PRD2050_R01')		{ component = Container_PRD2050_R01;   }
	else if (menuCd === 'PRD3010_R01')		{ component = Container_PRD3010_R01;   }
	else if (menuCd === 'PRD3011_R01')		{ component = Container_PRD3011_R01;   }
	else if (menuCd === 'PRD3012_R01')		{ component = Container_PRD3012_R01;   }
	else if (menuCd === 'PRD3020_R01')		{ component = Container_PRD3020_R01;   }
	else if (menuCd === 'PRD3030_R01')		{ component = Container_PRD3030_R01;   }
	else if (menuCd === 'PRD3031_R01')		{ component = Container_PRD3031_R01;   }
	else if (menuCd === 'PRD3040_R01')		{ component = Container_PRD3040_R01;   }
	else if (menuCd === 'PRD3050_R01')		{ component = Container_PRD3050_R01;   }
	else if (menuCd === 'PRD3060_R01')		{ component = Container_PRD3060_R01;   }
	else if (menuCd === 'PRD4060_R01')		{ component = Container_PRD4060_R01;   }
	else if (menuCd === 'PRD4010_R01')		{ component = Container_PRD4010_R01;   }
	else if (menuCd === 'PRD4011_R01')		{ component = Container_PRD4011_R01;   }
	else if (menuCd === 'PRD5010_R01')		{ component = Container_PRD5010_R01;   }
	else if (menuCd === 'PRD5011_R01')		{ component = Container_PRD5011_R01;   }
	else if (menuCd === 'PRD5020_R01')		{ component = Container_PRD5020_R01;   } // 성능가동율 조회 화면 메뉴코드 매핑
	else if (menuCd === 'PRD5030_R01')		{ component = Container_PRD5030_R01;   }
    else if (menuCd === 'PRD5040_R01')		{ component = Container_PRD5040_R01;   }
    else if(menuCd === 'PRD5050_R01')		{ component = Container_PRD5050_R01;   }

	else if (menuCd === 'PUR1020_R01')		{ component = Container_PUR1020_R01;   }
	else if (menuCd === 'PUR1021_R01')		{ component = Container_PUR1021_R01;   }
	else if (menuCd === 'PUR1030_R01')		{ component = Container_PUR1030_R01;   }
	else if (menuCd === 'PUR1040_R01')		{ component = Container_PUR1040_R01;   }
	else if (menuCd === 'PUR2010_R01')		{ component = Container_PUR2010_R01;   }
	else if (menuCd === 'PUR2020_R01')		{ component = Container_PUR2020_R01;   }
	else if (menuCd === 'PUR2040_R01')		{ component = Container_PUR2040_R01;   }
	else if (menuCd === 'PUR5010_R01')		{ component = Container_PUR5010_R01;   }
	else if (menuCd === 'PUR5020_R01')		{ component = Container_PUR5020_R01;   }
	else if (menuCd === 'PUR6010_R01')		{ component = Container_PUR6010_R01;   }

	else if (menuCd === 'SAL1010_R01')		{ component = Container_SAL1010_R01;   }
	else if (menuCd === 'SAL1011_R01')		{ component = Container_SAL1011_R01;   }
	else if (menuCd === 'SAL1020_R01')		{ component = Container_SAL1020_R01;   }
	else if (menuCd === 'SAL1030_R01')		{ component = Container_SAL1030_R01;   }
	else if (menuCd === 'SAL2020_R01')		{ component = Container_SAL2020_R01;   }
	else if (menuCd === 'SAL2030_R01')		{ component = Container_SAL2030_R01;   }
	else if (menuCd === 'SAL2040_R01')		{ component = Container_SAL2040_R01;   }
	else if (menuCd === 'SAL2050_R01')		{ component = Container_SAL2050_R01;   }
	else if (menuCd === 'SAL2060_R01')		{ component = Container_SAL2060_R01;   }
	else if (menuCd === 'SAL2070_R01')		{ component = Container_SAL2070_R01;   }
	else if (menuCd === 'SAL2080_R01')		{ component = Container_SAL2080_R01;   }
	else if (menuCd === 'SAL2090_R01')		{ component = Container_SAL2090_R01;   }
	else if (menuCd === 'SAL2110_R01')		{ component = Container_SAL2110_R01;   }
	else if (menuCd === 'SAL2100_R01')		{ component = Container_SAL2100_R01;   }
	else if (menuCd === 'SAL3010_R01')		{ component = Container_SAL3010_R01;   }
	else if (menuCd === 'SAL3050_R01')		{ component = Container_SAL3050_R01;   }
	else if (menuCd === 'SAL6010_R01')		{ component = Container_SAL6010_R01;   }
	else if (menuCd === 'SAL6020_R01')		{ component = Container_SAL6020_R01;   }
	else if (menuCd === 'SAL6030_R01')		{ component = Container_SAL6030_R01;   }

	else if (menuCd === 'SYS1010_R01')		{ component = Container_SYS1010_R01;   }
	else if (menuCd === 'SYS1020_R01')		{ component = Container_SYS1020_R01;   }
	else if (menuCd === 'SYS2010_R01')		{ component = Container_SYS2010_R01;   }
	else if (menuCd === 'SYS2020_R01')		{ component = Container_SYS2020_R01;   }
	else if (menuCd === 'SYS3010_R01')		{ component = Container_SYS3010_R01;   }
	else if (menuCd === 'SYS3020_R01')		{ component = Container_SYS3020_R01;   }
	else if (menuCd === 'SYS3050_R01')		{ component = Container_SYS3050_R01;   }
	else if (menuCd === 'SYS3060_R01')		{ component = Container_SYS3060_R01;   }
	else if (menuCd === 'SYS4010_R01')		{ component = Container_SYS4010_R01;   }
	else if (menuCd === 'SYS4030_R01')		{ component = Container_SYS4030_R01;   }
	else if (menuCd === 'SYS4090_R01')		{ component = Container_SYS4090_R01;   }
	else if (menuCd === 'HRM2130_R01')		{ component = Container_HRM2130_R01;   }
	else if (menuCd === 'HRM3130_R01')		{ component = Container_HRM3130_R01;   }
	else if (menuCd === 'HRM1060_R01')		{ component = Container_HRM1060_R01;   }
	else if (menuCd === 'HRM2040_R01')		{ component = Container_HRM2040_R01;   }
	else if (menuCd === 'HRM3110_R01')		{ component = Container_HRM3110_R01;   }
	else if (menuCd === 'HRM3050_R01')		{ component = Container_HRM3050_R01;   }
	else if (menuCd === 'HRM1040_R01')		{ component = Container_HRM1040_R01;   }
	else if (menuCd === 'HRM1030_R01')		{ component = Container_HRM1030_R01;   }
	else if (menuCd === 'HRM2120_R01')		{ component = Container_HRM2120_R01;   }
	else if (menuCd === 'HRM2010_R01')		{ component = Container_HRM2010_R01;   }
	else if (menuCd === 'SYS4100_R01')		{ component = Container_SYS4100_R01;   }
	else if (menuCd === 'SYS4110_R01')		{ component = Container_SYS4110_R01;   }
	else if (menuCd === 'SYS4120_R01')		{ component = Container_SYS4120_R01;   }
	else if (menuCd === 'SYS5010_R01')		{ component = Container_SYS5010_R01;   }
	else if (menuCd === 'SYS5020_R01')		{ component = Container_SYS5020_R01;   }

	else if (menuCd === 'WMS1020_R01')		{ component = Container_WMS1020_R01;   }
	else if (menuCd === 'WMS1021_R01')		{ component = Container_WMS1021_R01;   }
	else if (menuCd === 'WMS1022_R01')		{ component = Container_WMS1022_R01;   }
	else if (menuCd === 'WMS1030_R01')		{ component = Container_WMS1030_R01;   }
	else if (menuCd === 'WMS1031_R01')		{ component = Container_WMS1031_R01;   }
	else if (menuCd === 'WMS1060_R01')		{ component = Container_WMS1060_R01;   }
	else if (menuCd === 'WMS1100_R01')		{ component = Container_WMS1100_R01;   }
	else if (menuCd === 'WMS1101_R01')		{ component = Container_WMS1101_R01;   }
	else if (menuCd === 'WMS2010_R01')		{ component = Container_WMS2010_R01;   }
	else if (menuCd === 'WMS2011_R01')		{ component = Container_WMS2011_R01;   }
	else if (menuCd === 'WMS2020_R01')		{ component = Container_WMS2020_R01;   }
	else if (menuCd === 'WMS2021_R01')		{ component = Container_WMS2021_R01;   }
	else if (menuCd === 'WMS2040_R01')		{ component = Container_WMS2040_R01;   }
	else if (menuCd === 'WMS2060_R01')		{ component = Container_WMS2060_R01;   }
	else if (menuCd === 'WMS2061_R01')		{ component = Container_WMS2061_R01;   }
	// else if (menuCd === 'WMS1120_R01')	{ component = Container_WMS1120_R01;   }
	else if (menuCd === 'WMS1130_R01')		{ component = Container_WMS1130_R01;   }
	else if (menuCd === 'WMS1131_R01')		{ component = Container_WMS1131_R01;   }
	else if (menuCd === 'WMS1140_R01')		{ component = Container_WMS1140_R01;   }
	else if (menuCd === 'WMS1141_R01')		{ component = Container_WMS1141_R01;   }
	else if (menuCd === 'WMS2090_R01')		{ component = Container_WMS2090_R01;   }
	else if (menuCd === 'WMS2091_R01')		{ component = Container_WMS2091_R01;   }

	else if (menuCd === 'EQM1010_R01')		{ component = Container_EQM1010_R01;   }
	else if (menuCd === 'EQM1011_R01')		{ component = Container_EQM1011_R01;   }
	else if (menuCd === 'EQM1020_R01')		{ component = Container_EQM1020_R01;   }
	else if (menuCd === 'EQM1030_R01')		{ component = Container_EQM1030_R01;   }
	else if (menuCd === 'EQM2010_R01')		{ component = Container_EQM2010_R01;   }
	else if (menuCd === 'EQM2020_R01')		{ component = Container_EQM2020_R01;   }
	else if (menuCd === 'EQM2040_R01')		{ component = Container_EQM2040_R01;   }
	else if (menuCd === 'EQM2050_R01')		{ component = Container_EQM2050_R01;   }
	else if (menuCd === 'EQM2060_R01')		{ component = Container_EQM2060_R01;   }
	else if (menuCd === 'EQM2070_R01')		{ component = Container_EQM2070_R01;   }
	else if (menuCd === 'TQC2100_R01')		{ component = Container_TQC2100_R01;   }
	else if (menuCd === 'EQM2080_R01')		{ component = Container_EQM2080_R01;   }
	else if (menuCd === 'EQM3010_R01')		{ component = Container_EQM3010_R01;   }
	else if (menuCd === 'EQM3020_R01')		{ component = Container_EQM3020_R01;   }
	else if (menuCd === 'EQM4010_R01')		{ component = Container_EQM4010_R01;   }

	else if (menuCd === 'TQC1020_R01')		{ component = Container_TQC1020_R01;   }
	else if (menuCd === 'TQC1040_R01')		{ component = Container_TQC1040_R01;   }
	else if (menuCd === 'TQC1050_R01')		{ component = Container_TQC1050_R01;   }
	else if (menuCd === 'TQC1060_R01')		{ component = Container_TQC1060_R01;   }
	else if (menuCd === 'TQC2010_R01')		{ component = Container_TQC2010_R01;   }
	else if (menuCd === 'TQC2011_R01')		{ component = Container_TQC2011_R01;   }
	else if (menuCd === 'TQC2020_R01')		{ component = Container_TQC2020_R01;   }
	else if (menuCd === 'TQC2050_R01')		{ component = Container_TQC2050_R01;   }
	else if (menuCd === 'TQC2060_R01')		{ component = Container_TQC2060_R01;   }
    else if(menuCd === 'TQC2070_R01')		{ component = Container_TQC2070_R01;   }
	else if (menuCd === "TQC2080_R01")		{ component = Container_TQC2080_R01;   }
	else if (menuCd === 'TQC2090_R01')		{ component = Container_TQC2090_R01;   }
	else if (menuCd === 'TQC3010_R01')		{ component = Container_TQC3010_R01;   }
	else if (menuCd === 'TQC3020_R01')		{ component = Container_TQC3020_R01;   }
	else if (menuCd === 'TQC5010_R01')		{ component = Container_TQC5010_R01;   }
	else if (menuCd === 'TQC5020_R01')		{ component = Container_TQC5020_R01;   }


    return component;
};

export const getMenuDisplayNm = (menuCd: string, menuNm: string): string => {
	if (menuCd === 'WMS1022_R01') {
		return '입고 등록(백업)';
	}
	return menuNm;
};


	//메뉴 아이콘 설정
export const menuIcon_First = (menu: Partial<MenuDto> & { menuCd: string, menuNm: string }): JSX.Element => {
	const availableIcons = ['$$$', 'MST', 'ACC', 'TQC', 'HRM', 'SAL', 'SYS', 'EQM', 'PRD', 'WMS', 'PUR'];

	if (availableIcons.includes(menu.menuCd)) {
		return <img src={`${process.env.PUBLIC_URL}/MESICON/${menu.menuCd}.png`} alt={menu.menuCd.toLowerCase()} className="w-[20px] h-[20px] mr-2" />;
	} else {
		return <FolderOutlined style={{ color: '#ffffff', fontSize: '20px', marginRight: '4px' }} />;
	}
}
